var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"core-footer","absolute":"","height":"82"}},[_c('v-spacer'),_c('span',{staticClass:"font-weight-light copyright"},[_vm._v("\n    ©\n    "+_vm._s((new Date()).getFullYear())+"\n    Inkasso\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }